import { gql } from '@apollo/client'
import { InvoicingWelcomeModal } from 'features/Invoicing'

import { CorporateCardStartup } from './CorporateCardStartup/CorporateCardStartup'
import { CustomScreensaverModal } from './CustomScreensaverModal/CustomScreensaverModal'
import { type StartUpModal } from './hooks/useStartupModalsSession/useStartupModalsSession.types'
import { NotificationsModal } from './NotificationsModal/NotificationsModal'
import { PushAppModal } from './PushAppModal/PushAppModal'
import { SavingsStartup } from './SavingsStartup/SavingsStartup'
import { SavingsStartupMarch } from './SavingsStartupMarch/SavingsStartupMarch'
import { SetupFlowProvider } from './SetupFlow/contexts/SetupFlowProvider'
import { SetupFlow } from './SetupFlow/SetupFlow'
import {
  StartupModalSwitchDebitCardAccountV2Fragment,
  StartupModalSwitchEntityFragment,
} from './StartupModalSwitch.generated'
import { TapToPayModal } from './TapToPayModal/TapToPayModal'
import { XeroErrorModal } from './XeroErrorModal/XeroErrorModal'

type StartupModalSwitchProps = {
  startupModal: StartUpModal
  savingsAccount: StartupModalSwitchDebitCardAccountV2Fragment | null
  entity: StartupModalSwitchEntityFragment | null
}

export const StartupModalSwitch = ({
  startupModal,
  savingsAccount,
  entity,
}: StartupModalSwitchProps) => {
  switch (startupModal) {
    case 'setup':
      return (
        <SetupFlowProvider>
          <SetupFlow />
        </SetupFlowProvider>
      )
    case 'xero':
      return <XeroErrorModal />
    case 'savingsAccountMarch':
      return entity?.savingsAccountProduct ? (
        <SavingsStartupMarch savingsAccount={savingsAccount} entity={entity} />
      ) : null
    case 'savingsAccount':
      return entity?.savingsAccountProduct ? (
        <SavingsStartup savingsAccount={savingsAccount} entity={entity} />
      ) : null
    case 'corporateCard':
      return <CorporateCardStartup />
    case 'tapToPay':
      return <TapToPayModal />
    case 'customScreensaver':
      return <CustomScreensaverModal />
    case 'notification':
      return <NotificationsModal />
    case 'invoicing':
      return <InvoicingWelcomeModal />
    case 'pushApp':
      return <PushAppModal />
    default:
      return null
  }
}

StartupModalSwitch.fragments = {
  Entity: gql`
    fragment StartupModalSwitchEntityFragment on Entity {
      ...SavingsStartupEntityFragment
      ...SavingsStartupMarchEntityFragment
    }

    ${SavingsStartup.fragments.Entity}
    ${SavingsStartupMarch.fragments.Entity}
  `,
  DebitCardAccountV2: gql`
    fragment StartupModalSwitchDebitCardAccountV2Fragment on DebitCardAccountV2 {
      ...SavingsStartupDebitCardAccountV2Fragment
      ...SavingsStartupMarchDebitCardAccountV2Fragment
    }

    ${SavingsStartup.fragments.DebitCardAccountV2}
    ${SavingsStartupMarch.fragments.DebitCardAccountV2}
  `,
}
